import { useState } from "react";
import Modal from 'react-modal';

const InterstedModal = ({ isOpen, onClose,  Users }) => {
    console.log("Attendees:",   Users); // Now logging attendees instead of    Users
    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedImages, setSelectedImages] = useState([]);

    if (!isOpen || !    Users ||     Users.length === 0) return null;

    return (
        <div className='detail-page-modal'>
            <div className='modal-header'>
                <h3>Interested Users</h3>
                <button className='cross' onClick={onClose}>
                    <img src={window.getPublicUrl('/assets/images/gray-cross.svg')} alt='close' />
                </button>
            </div>
            <div className='modal-body scrollable-modal-body'>
                {   Users.map((attendee, index) => (
                    <div key={index} className="review-main">
                        <div className="d-flex align-items-center">
                           <span>
                           <img
                                src={attendee?.User?.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                                alt="attendee"
                                className="thumbnail"
                                height={50}
                                width={50}
                            />
                           </span>
                            <div className="review-name-main ml-3">
                                <p className="review-name">{attendee?.User?.name || "Unknown"}</p>
                                <p className="sur-name">{attendee?.User?.user_name || "Unknown"}</p>
                            </div>
                        </div>
                       
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InterstedModal;
